<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Affiliation History</h4>
</div>
<div class="modal-body">
    <historical-customer-affiliation [customerNumberId]="data.customerNumberId"></historical-customer-affiliation>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--primary" type="button" (click)="cancel()">Close</button>
    </div>
</div>
